export default "__VITE_ASSET__Dyf7jr03__"